import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';
import { JOIN_TIMEOUT_MS } from '@/modules/webrtc/agora/const';

export default {
  // join channel
  async joinChannel() {
    const lessonId = this.channelName;
    const meta = buildJoinMeta({ provider: 'agora', lessonId });
    const prefix = joinPrefix('Agora');

    logger.info(`${prefix} rtc.join() call starting`, meta);

    const joinStart = Date.now();

    // Proactive timeout warning — fires while join is still pending
    const timeoutTimer = setTimeout(() => {
      const elapsed = Date.now() - joinStart;
      logger.warn(
        `${prefix} rtc.join() still pending after ${elapsed}ms (exceeds ${JOIN_TIMEOUT_MS}ms threshold)`,
        buildJoinMeta({ provider: 'agora', lessonId, extra: { event_type: 1 } })
      );
    }, JOIN_TIMEOUT_MS);

    try {
      const uid = await this.rtc.join(
        this.AppId,
        this.channelName,
        this.channelToken,
        this.userId
      );

      clearTimeout(timeoutTimer);

      const elapsed = Date.now() - joinStart;
      logger.info(
        `${prefix} rtc.join() succeeded - uid: ${uid}, elapsed: ${elapsed}ms`,
        buildJoinMeta({ provider: 'agora', lessonId })
      );

      if (elapsed > JOIN_TIMEOUT_MS) {
        logger.warn(
          `${prefix} rtc.join() was slow: exceeded ${JOIN_TIMEOUT_MS}ms threshold`,
          buildJoinMeta({ provider: 'agora', lessonId, extra: { event_type: 1 } })
        );
      }

      return uid;
    } catch (err) {
      clearTimeout(timeoutTimer);

      const elapsed = Date.now() - joinStart;
      logger.error(
        `${prefix} rtc.join() failed - error: ${err.message}, code: ${err.code}, elapsed: ${elapsed}ms`,
        meta
      );

      throw err;
    }
  }
}
